export default "__VITE_ASSET__b_8vE4iC__"